import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, FolderIcon, StickyNoteIcon, GlobeIcon } from 'lucide-react';
import { useWindows } from '../context/WindowsContext';
interface DesktopFile {
  id: string;
  name: string;
  icon: React.ReactNode;
  color: string;
  onOpen: () => void;
}
export const DesktopIcons: React.FC = () => {
  const {
    openApp
  } = useWindows();
  const files: DesktopFile[] = [{
    id: 'resume',
    name: 'Resume.pdf',
    icon: <FileTextIcon size={26} className="text-red-100" data-id="element-309" data-mp="1zgeke8npc68v" />,
    color: 'bg-red-500',
    onOpen: () => openApp('resume')
  }, {
    id: 'projects-folder',
    name: 'Projects',
    icon: <FolderIcon size={26} className="text-white fill-white/30" data-id="element-310" data-mp="28h2wgxtjbwj4" />,
    color: 'bg-blue-500',
    onOpen: () => openApp('xcode')
  }, {
    id: 'readme',
    name: 'README.md',
    icon: <FileTextIcon size={26} className="text-white" data-id="element-311" data-mp="3jw8ed928m1nb" />,
    color: 'bg-gray-700',
    onOpen: () => openApp('finder')
  }, {
    id: 'notes',
    name: 'Notes.txt',
    icon: <StickyNoteIcon size={26} className="text-yellow-100" data-id="element-312" data-mp="2gwsrgjdppn9w" />,
    color: 'bg-yellow-500',
    onOpen: () => openApp('terminal')
  }, {
    id: 'my-portfolio',
    name: 'My Portfolio',
    icon: <GlobeIcon size={26} className="text-white" data-id="element-313" data-mp="2qr1h8zbcz24d" />,
    color: 'bg-indigo-600',
    onOpen: () => openApp('safari-portfolio')
  }];
  return <div className="absolute top-4 right-4 flex flex-col gap-4 z-10" data-id="element-314" data-mp="1y59q0gzc6h9z">
      {files.map((file, index) => <motion.button key={file.id} initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.6 + index * 0.08
    }} onDoubleClick={file.onOpen} onClick={file.onOpen} className="group flex flex-col items-center gap-1 w-20 p-2 rounded-lg hover:bg-white/10 focus:bg-blue-500/30 outline-none transition-all hover:-translate-y-0.5" aria-label={`Open ${file.name}`} data-id="element-315" data-mp="2342ytw3ohk3t" data-mpi={index}>
          <div className={`w-14 h-14 ${file.color} rounded-xl flex items-center justify-center shadow-lg relative overflow-hidden`} data-id="element-316" data-mp="17dsyfbelc92c">
            <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" data-id="element-317" data-mp="1m40a98a3etu2" />
            {file.icon}
          </div>
          <span className="text-xs text-white font-medium px-1.5 py-0.5 rounded bg-black/30 backdrop-blur-sm text-center leading-tight max-w-full truncate" data-id="element-318" data-mp="teb5cju9i9n6">
            {file.name}
          </span>
        </motion.button>)}
    </div>;
};